/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  clean search term helper
 */

const stripSearchTerm = (term: string) =>
  term
    .replace(/\s{2,}/g, ' ')
    .trim()
    .toLowerCase()

export default stripSearchTerm
